module.exports = __webpack_public_path__ + "c6a0aae79d98c39d878994c5d8dd8ac7.png";